import qs from "qs";
import get from "lodash/get";
import { api } from "../config";

const getEvent = async (slug) => {
  const query = qs.stringify(
    {
      filters: {
        Slug: {
          $eq: slug,
        },
      },
      populate: {
        Content: {
          populate: {
            Link: {
              populate: {
                page: {
                  fields: ["Slug"],
                },
              },
            },
            Media: "*",
            associations: {
              populate: "*",
            },
            contacts: {
              populate: "*",
            },
            brands: {
              populate: "*",
            },
            product: {
              populate: {
                Hero: {
                  populate: ["Media"],
                },
                Page: {
                  fields: ["Slug"],
                },
              },
            },
          },
        },
        Media: "*",
        Gallery: {
          populate: {
            Media: "*",
          },
        },
        EventRegistration: "*",
      },
    },
    {
      encodeValuesOnly: true,
    }
  );

  const res: any = await fetch(`${api}/events?${query}`);
  res.data = await res.json();
  if (get(res, "data.data[0]")) res.data.data = res.data.data[0];
  return res;
};

export { getEvent };
